{
  "name": "npm-check-updates",
  "version": "22.2.0",
  "author": "Tomas Junnonen <tomas1@gmail.com>",
  "license": "Apache-2.0",
  "contributors": [
    "Raine Revere (https://github.com/raineorshine)",
    "Imamuzzaki Abu Salam <imamuzzaki@gmail.com>"
  ],
  "description": "Find newer versions of dependencies than what your package.json allows",
  "keywords": [
    "dependencies",
    "npm",
    "package.json",
    "update",
    "upgrade",
    "versions"
  ],
  "engines": {
    "node": "^20.19.0 || ^22.12.0 || >=24.0.0",
    "npm": ">=10.0.0"
  },
  "type": "module",
  "main": "build/index.cjs",
  "module": "build/index.js",
  "types": "build/index.d.ts",
  "bin": {
    "npm-check-updates": "build/cli.js",
    "ncu": "build/cli.js"
  },
  "exports": {
    ".": {
      "types": "./build/index.d.ts",
      "import": "./build/index.js",
      "require": "./build/index.cjs"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "rimraf build && vite build",
    "build:options": "tsx src/scripts/build-options.ts",
    "build:analyze": "rimraf build && ANALYZER=true vite build",
    "lint": "cross-env FORCE_COLOR=1 npm-run-all --parallel --aggregate-output lint:*",
    "lint:lockfile": "lockfile-lint",
    "lint:types": "tsc --noEmit",
    "lint:markdown": "markdownlint \"**/*.md\" --ignore \"**/node_modules/**/*.md\" --ignore build --config .markdownlint.json",
    "lint:src": "eslint --cache --cache-location node_modules/.cache/.eslintcache --report-unused-disable-directives",
    "prepare": "src/scripts/install-hooks",
    "prepublishOnly": "npm run build",
    "prettier": "prettier . --check",
    "prettier:fix": "prettier . --write",
    "test": "tsc --noEmit && npm run test:unit && npm run test:e2e",
    "test:bun": "mocha test/bun",
    "test:unit": "mocha test test/package-managers/* --ignore 'test/bun/*'",
    "test:e2e": "./test/e2e.sh",
    "typecheck": "tsc --noEmit",
    "ncu": "node build/cli.js"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/raineorshine/npm-check-updates.git"
  },
  "homepage": "https://github.com/raineorshine/npm-check-updates",
  "bugs": {
    "url": "https://github.com/raineorshine/npm-check-updates/issues"
  },
  "overrides": {
    "typescript": "$typescript",
    "eslint": "$eslint",
    "eslint-config-standard": {
      "eslint-plugin-n": "$eslint-plugin-n",
      "eslint-plugin-promise": "$eslint-plugin-promise"
    },
    "@verdaccio/core": ">=8.0.0-next-8.33",
    "chai-string": {
      "chai": "$chai"
    },
    "diff": ">=8.0.3",
    "ip-address": ">=10.1.1",
    "lodash": ">=4.18.1",
    "serialize-javascript": ">=7.0.3",
    "uuid": ">=14.0.0"
  },
  "devDependencies": {
    "@eslint/compat": "^2.0.5",
    "@eslint/js": "^10.0.1",
    "@streamparser/json": "^0.0.22",
    "@trivago/prettier-plugin-sort-imports": "^6.0.2",
    "@types/bun": "^1.3.11",
    "@types/chai": "^5.2.3",
    "@types/chai-as-promised": "^8.0.2",
    "@types/chai-string": "^1.4.5",
    "@types/cli-table": "^0.3.4",
    "@types/hosted-git-info": "^3.0.5",
    "@types/ini": "^4.1.1",
    "@types/js-yaml": "^4.0.9",
    "@types/jsonlines": "^0.1.5",
    "@types/lodash-es": "^4.17.12",
    "@types/mocha": "^10.0.10",
    "@types/node": "^25.6.0",
    "@types/npm-registry-fetch": "^8.0.9",
    "@types/parse-github-url": "^1.0.3",
    "@types/picomatch": "^4.0.3",
    "@types/progress": "^2.0.7",
    "@types/prompts": "^2.4.9",
    "@types/semver": "^7.7.1",
    "@types/semver-utils": "^1.1.3",
    "@types/sinon": "^21.0.1",
    "@types/update-notifier": "^6.0.8",
    "@typescript-eslint/eslint-plugin": "^8.59.0",
    "@typescript-eslint/parser": "^8.59.0",
    "camelcase": "^9.0.0",
    "chai": "^6.2.2",
    "chai-as-promised": "^8.0.2",
    "chai-string": "^1.6.0",
    "chalk": "^5.6.2",
    "cli-table3": "^0.6.5",
    "commander": "^14.0.3",
    "cosmiconfig": "^9.0.1",
    "cross-env": "^10.1.0",
    "dequal": "^2.0.3",
    "eslint": "^10.2.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-config-raine": "^0.5.0",
    "eslint-config-standard": "^17.1.0",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import-x": "^4.16.2",
    "eslint-plugin-jsdoc": "^62.9.0",
    "eslint-plugin-n": "^18.0.1",
    "eslint-plugin-promise": "^7.2.1",
    "fast-glob": "^3.3.3",
    "fast-memoize": "^2.5.2",
    "find-up": "^8.0.0",
    "fp-and-or": "^1.0.2",
    "globals": "^17.5.0",
    "hosted-git-info": "^9.0.2",
    "ini": "^6.0.0",
    "js-yaml": "^4.1.1",
    "jsonc-parser": "^3.3.1",
    "jsonlines": "^0.1.1",
    "lockfile-lint": "^5.0.0",
    "lodash-es": "^4.18.1",
    "markdownlint-cli": "^0.48.0",
    "mocha": "^11.7.5",
    "npm-registry-fetch": "^19.1.1",
    "npm-run-all": "^4.1.5",
    "p-map": "^7.0.4",
    "parse-github-url": "^1.0.4",
    "picomatch": "^4.0.4",
    "prettier": "^3.8.3",
    "progress": "^2.0.3",
    "prompts-ncu": "^3.0.2",
    "rfdc": "^1.4.1",
    "rimraf": "^6.1.3",
    "semver": "^7.7.4",
    "semver-utils": "^1.1.4",
    "should": "^13.2.3",
    "sinon": "^21.1.2",
    "source-map-support": "^0.5.21",
    "spawn-please": "^3.0.0",
    "timeago.js": "^4.0.2",
    "ts-json-schema-generator": "^2.9.0",
    "tsx": "^4.21.0",
    "typescript": "^6.0.3",
    "untildify": "^6.0.0",
    "update-notifier": "^7.3.1",
    "verdaccio": "^6.5.2",
    "vite": "^8.0.8",
    "vite-bundle-analyzer": "^1.3.7",
    "vite-plugin-dts": "^4.5.4",
    "yaml": "^2.8.3",
    "yarn": "^1.22.22",
    "zod": "^4.3.6"
  },
  "files": [
    "build",
    "!**/test/**"
  ],
  "lockfile-lint": {
    "allowed-schemes": [
      "https:",
      "git+ssh:"
    ],
    "allowed-hosts": [
      "npm",
      "github.com"
    ],
    "empty-hostname": false,
    "type": "npm ",
    "path": "package-lock.json"
  },
  "mocha": {
    "check-leaks": true,
    "extension": [
      "test.ts"
    ],
    "node-option": [
      "import=tsx",
      "enable-source-maps",
      "trace-deprecation",
      "trace-warnings",
      "no-warnings=TimeoutNaNWarning"
    ],
    "timeout": 60000,
    "recursive": true,
    "exit": true
  }
}
